import { CIRCLE_ANGLE } from '../../constants';
import { IRating } from '../../types/developer/ratings';
import { IPieChartData } from '../../types/pieChart/data';

export interface ICoordinates {
  x: number;
  y: number;
}

export interface IArc {
  start: ICoordinates;
  radius: number;
  startAngle: number;
  endAngle: number;
}

export function polarToCartesian(centerX: number, centerY: number, radius: number, angleInDegrees: number) {
  const angleInRadians = ((angleInDegrees - 90) * Math.PI) / 180.0;

  return {
    x: centerX + radius * Math.cos(angleInRadians),
    y: centerY + radius * Math.sin(angleInRadians),
  };
}

export function describeArc({ start: { x, y }, radius, startAngle, endAngle }: IArc) {
  const start = polarToCartesian(x, y, radius, endAngle);
  const end = polarToCartesian(x, y, radius, startAngle);

  const largeArcFlag = endAngle - startAngle <= 180 ? '0' : '1';

  return ['M', start.x, start.y, 'A', radius, radius, 0, largeArcFlag, 0, end.x, end.y].join(' ');
}

export interface IArcSettings {
  width: number;
  strokeWidth: number;
  startCoordinates: ICoordinates;
}

export function getArcs(rating: IRating, settings: IArcSettings) {
  const radius = settings.width / 2 - settings.strokeWidth / 2;

  return rating.graph.data.reduce<IPieChartData[]>((acc, curr, index) => {
    const ratio = curr.value / rating.graph.maxRating;
    const startAngle = index === 0 ? 0 : acc[index - 1].endAngle;
    const endPoint = index === 0 ? 0 : startAngle;
    const endAngle = Math.round(endPoint + CIRCLE_ANGLE * ratio);
    const d = describeArc({ start: settings.startCoordinates, startAngle, endAngle, radius });

    return [...acc, { startAngle, endAngle, stroke: curr.color, fill: 'none', d, strokeWidth: settings.strokeWidth }];
  }, []);
}
